import { GridRowSelectionModel } from '@mui/x-data-grid-pro'
import { createContext } from 'react'
import { SubcontractorRequest } from 'src/interfaces/subcontractor'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface ISubcontractorRequestsTableContext extends IColumnManagerContext {
  searchQuery: string
  setSearchQuery(value: string): void

  masterContractorFilter: Array<string>
  setMasterContractorFilter(masterContractorFilter: Array<string>): void

  actionAnchor: null | HTMLElement
  subcontractorRequestToAction: SubcontractorRequest | null
  openSubcontractorRequestItemAction(
    event: React.MouseEvent<HTMLButtonElement>,
    subcontractorRequest: SubcontractorRequest,
  ): void
  closeSubcontractorRequestItemAction(): void
  clearSubcontractorRequestToAction(): void

  selectedSubcontractorRequestIds: GridRowSelectionModel
}

export const SubcontractorRequestsTableContext = createContext<ISubcontractorRequestsTableContext>({
  ...defaultColumnManagerContext,

  searchQuery: '',
  setSearchQuery: () => {},

  masterContractorFilter: [],
  setMasterContractorFilter: () => {},

  actionAnchor: null,
  subcontractorRequestToAction: null,
  openSubcontractorRequestItemAction: () => {},
  closeSubcontractorRequestItemAction: () => {},
  clearSubcontractorRequestToAction: () => {},

  selectedSubcontractorRequestIds: [],
})
